import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LayoutService } from '../services';

@Component({
  selector: 'lib-blade',
  template: `
    <aside
      *ngIf="{ showSettings: layoutSvc.showSettings$ | async } as options"
      class="customizer"
      [ngClass]="{ 'show-service-panel': options.showSettings }"
    >
      <a
        *ngIf="false"
        href="javascript:void(0)"
        class="btn-dark btn btn-circle btn-lg service-panel-toggle"
        (click)="toggleSettings()"
      >
        <i class="fa fa-spin fa-cog"></i>
      </a>
      <div class="customizer-body custom-pills" [perfectScrollbar]>
        <ul
          ngbNav
          #settingsNav="ngbNav"
          class="nav-pills justify-content-center"
        >
          <li ngbNavItem="chat">
            <a ngbNavLink>
              <i class="mdi mdi-message-reply font-20"></i>
            </a>
            <ng-template ngbNavContent>
              <ng-content></ng-content>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="settingsNav" class="mt-2"></div>
      </div>
    </aside>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BladeComponent {
  constructor(public layoutSvc: LayoutService) {}

  toggleSettings() {
    this.layoutSvc.toggleSettings();
  }
}
